"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = clamp;
function clamp(value, min, max) {
    const clampMin = typeof min === "number" ? Math.max(value, min) : value;
    return typeof max === "number" ? Math.min(clampMin, max) : clampMin;
}
